import { render, staticRenderFns } from "./GameInfo.vue?vue&type=template&id=d6996016&scoped=true&"
import script from "./GameInfo.vue?vue&type=script&lang=js&"
export * from "./GameInfo.vue?vue&type=script&lang=js&"
import style0 from "./GameInfo.vue?vue&type=style&index=0&id=d6996016&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6996016",
  null
  
)

export default component.exports